import React from 'react';
//import useEffect from 'react';
import connect from "react-redux/es/components/connect";

const FooterSupervisor = (props) => {

    return (
        <div className="footer-bar">
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <span className="footer-copyright">
                            Copyright 2024, <a href="/">Progress Malta Limited</a>. All Rights Reserved.
                        </span>
                    </div>
                    {/* .col */}
                    <div className="col-md-5 text-md-end">
                        <ul className="footer-links">
                            <li>
                                <a href="policy.html">Privacy Policy</a>
                            </li>
                            <li>
                                <a href="policy.html">Terms of Sales</a>
                            </li>
                        </ul>
                    </div>
                    {/* .col */}
                </div>
                {/* .row */}
            </div>
            {/* .container */}
        </div>
    );
};

const mapStateToProps = state => {
    return {};
};

export default connect(mapStateToProps, {
})(FooterSupervisor);
